// React imports.
import React from "react";

import { Assessment3aStepsEnum } from "../state";
import { Assessment3aVendorAssignedStatusEnum } from "../state";


const Assessment3aTopParagraph = ({fuelType, state }) => (
    <div>
        {(fuelType.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Over95NoIssues)
          &&  <p>
                <strong>
                    Status: No data reliability issue present!
                </strong>&nbsp;
                Your data recording and processing efforts for  {fuelType.description}   households
                have not been flagged because more than   {fuelType.targetPercentHouseholdsCoveredString}    of
                your  {fuelType.description}   households have an electric vendor listed on file.
            </p>
        }
        {(fuelType.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed)
        &&
            <p>
                <strong>
                    Status: N/A -
                </strong>&nbsp;
                You indicated that you DO NOT serve households that
                heat with &nbsp;{fuelType.description}. Therefore,
                there is no data here to check. Please click next.
            </p>
        }
        {(fuelType.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget)
          &&
          <p>
              <strong>
                  Status: Potential data reliability issue present!  
              </strong>&nbsp;
              Your data recording and processing efforts for  {fuelType.description}   households
              have been flagged because you only have   {fuelType.vendorAssignmentPercentString}    of
              your households assigned to an electric vendor, which does not meet the 95% target.
          </p>
        }
    </div>
);

export default Assessment3aTopParagraph;
